const headers = accessToken => [
    {key: "Authorization", value: "Bearer " + accessToken }
];

const fetchDeployments = http => apiUrl => accessToken => () => {

    const url = `${apiUrl}/deployments`;
    return http("GET", url, headers(accessToken))
        .catch (() => Promise.reject("REMOTE ERROR"))
        .then( r => {
            if (r.status !== 200) {
                return Promise.reject("ERROR RESPONSE");
            } else if (!r.payload || !r.payload.result || !(Array.isArray(r.payload.result))) {
                return Promise.reject("UNEXPECTED CONTENT");
            } else return r;
        })
        .then(r => r.payload.result);
};

export {fetchDeployments};



// WEBPACK FOOTER //
// ./src/deployments/deployments-service.js